import authService from '@/modules/Auth/auth-services'
import { User } from '@/modules/Auth/classes/User'
import { ClinicAndFlags } from '@/modules/Auth/auth-types'

export const setupInsiderSdk = async (user: User) => {
  const userClinic: ClinicAndFlags = await authService.getClinic(user.token)
  const patientId = user.patientId

  // TODO: when removing braze, rename the flag to PermiteEnvioCRM
  const allowCRM = userClinic?.flags?.PermiteEnvioBraze

  const existingScript = document.getElementById('insiderTag')

  if (!patientId || !allowCRM) {
    if (existingScript) {
      document.body.removeChild(existingScript)
      const worker = document.getElementById('insider-worker')
      if (worker) {
        document.body.removeChild(worker)
      }
    }
    return
  }

  // all the insider work is done by the queue, indo which we push the events in
  // certain order and they are taken care of by the insider worker
  window.InsiderQueue = []

  window.InsiderQueue.push({
    type: 'user',
    value: {
      uuid: String(patientId),
      email: user.email,
      name: user.name,
      gdpr_optin: true,
    },
  })

  window.InsiderQueue.push({
    type: 'init',
  })

  // insider has no real SDK, just a script that enable its features
  // we can only inport the script after the queue object is populated
  if (!existingScript) {
    const script = document.createElement('script')
    script.id = 'insiderTag'
    script.setAttribute('data-patient', String(patientId))
    script.src = process.env.VITE_APP_INSIDER_SCRIPT_URL
    script.async = true
    document.body.appendChild(script)
    return
  }

  // if the user changed clinic, then we need to re-initialize the integration
  existingScript.setAttribute('data-patient', String(patientId))
  window.Insider.eventManager.dispatch('init-manager:re-initialize')
}

export const sendInsiderCustomEvent = (event: string, payload: unknown) => {
  window.Insider?.track('events', [
    {
      event_name: normalize(event),
      event_params: {
        custom: payload,
      },
    },
  ])
}

/**
 * Normalize a string according to the Insider requirements:
 * - should start with a letter
 * - every character should be in lower case
 * - no special symbols or spaces
 * - characters - and _ are allowed
 * - numbers are allowed
 *
 * @param input raw event or property name
 * @return cleaned up name that should be accepted by the insider api
 */
const normalize = (input: string): string => {
  const WHITE_SPACE_REGEX = /\s/g
  const NON_LATIN_REGEX = /[^\w-]/g
  const STARTS_WITH_NUMBER_REGEX = /^\d/
  const DIGIT_NAME_PREFIX = 'p_'

  const noWhitespace = input.trim().replace(WHITE_SPACE_REGEX, '_')
  const normalized = noWhitespace.normalize('NFD')
  let slug = normalized.replace(NON_LATIN_REGEX, '')

  if (STARTS_WITH_NUMBER_REGEX.test(slug.charAt(0))) {
    slug = `${DIGIT_NAME_PREFIX}${slug}`
  }

  return slug.toLowerCase()
}
